SDG.setCookie = function(cName, value, exp, unit = "days") {
  const exdate = /* @__PURE__ */ new Date();
  if (unit === "hours") {
    exdate.setTime(exdate.getTime() + exp * 60 * 60 * 1e3);
  } else {
    exdate.setDate(exdate.getDate() + exp);
  }
  const cValue = encodeURI(value) + `; expires=${exdate.toUTCString()}`;
  document.cookie = `${cName}=${cValue}; path=/`;
};
SDG.getCookie = function(cName) {
  let i;
  let x;
  let y;
  const ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i += 1) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x === cName) {
      return decodeURI(y);
    }
  }
  return false;
};
SDG.deleteCookie = function(cName) {
  document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
function uniqueId() {
  const crypto = window.crypto || window.msCrypto;
  return ("10000000100040008000" + 1e11).replace(/[018]/g, (c) => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}
const setAndGetSearchspringCookies = () => {
  let sessionCookie = SDG.getCookie("ssSessionIdNamespace");
  if (!sessionCookie) {
    sessionCookie = uniqueId();
    SDG.setCookie("ssSessionIdNamespace", sessionCookie, 1);
  }
  let userId = SDG.getCookie("ssUserId");
  if (!userId) {
    userId = uniqueId();
    SDG.setCookie("ssUserId", userId, 30);
  }
  const pageLoadId = uniqueId();
  return {
    sessionCookie,
    userId,
    pageLoadId
  };
};
export {
  setAndGetSearchspringCookies as s
};
